/* eslint-disable @typescript-eslint/no-explicit-any */
import 'react-datepicker/dist/react-datepicker.css'
import './style.css'

import DatePicker from 'react-datepicker'

interface DatePickerCompProps {
  startDate?: Date | null
  handleChangeStartDate: (date: any) => void
  endDate?: Date | null
  handleChangeEndDate: (date: any) => void
  addLink: Date | string
  hideLink: Date | string
}

export const DatePickerComp: React.FC<DatePickerCompProps> = ({
  startDate,
  handleChangeStartDate,
  handleChangeEndDate,
  endDate,
  addLink,
  hideLink,
}) => {
  const addLinkStr = new Date(addLink).toLocaleString()
  const hideLinkStr = new Date(hideLink).toLocaleString()

  return (
    <>
      <div className='lg:w-1/2'>
        <p className="mb-3 text-base font-semibold">Add Link</p>
        <DatePicker
          selected={startDate}
          onChange={handleChangeStartDate}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          showTimeSelect
          dateFormat="Pp"
          placeholderText="Date/Time"
        />
      </div>
      <div className='lg:w-1/2'>
        <p className="mb-3 text-base font-semibold">Hide Link</p>
        <DatePicker
          selected={endDate}
          onChange={handleChangeEndDate}
          selectsEnd
          dateFormat="Pp"
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          showTimeSelect
          placeholderText="Date/Time"
        />
      </div>
    </>
  )
}
